<template>
  <nav class="navbar navbar-fixed-top navbar-transparent" role="navigation">
    <div class="container">
      <div class="navbar-header">
        <button id="menu-toggle" type="button" class="navbar-toggle">
          <span class="sr-only">Toggle navigation</span>
          <span class="icon-bar bar1"></span>
          <span class="icon-bar bar2"></span>
          <span class="icon-bar bar3"></span>
        </button>
        <a class="navbar-brand" href="#">Story</a>
      </div>
    </div>
  </nav>
  <div class="wrapper">
    <div class="parallax filter-black">
      <div class="parallax-image"></div>
      <div class="small-info">
        <div
          class="col-sm-10 col-sm-push-1 col-md-6 col-md-push-3 col-lg-6 col-lg-push-3"
        >
          <div class="card">
            <div class="card-block">
              <div class="center">
                <h2>Log in to continue your story</h2>
                <form action="http://localhost:3009/auth" method="get">
                  <input required name="client_id" value="app" hidden />
                  <input name="resource" value="" hidden />
                  <input required name="response_type" value="code" hidden />
                  <input
                    required
                    name="redirect_uri"
                    value="http://localhost:8080/auth"
                    hidden
                  />
                  <input
                    required
                    name="scope"
                    value="openid offline_access api:read profile email address phone"
                    hidden
                  />
                  <input required name="prompt" value="consent" hidden />
                  <input
                    required
                    name="code_challenge"
                    v-model="challengeCode"
                    hidden
                  />
                  <input
                    required
                    name="code_challenge_method"
                    value="S256"
                    hidden
                  />
                  <button class="login-btn">Log in with chitchat</button>
                </form>
                <a href="http://localhost:3009/signup"
                  >Don't have an account? Sign up</a
                >
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <footer class="footer">
      <div class="container">
        <p class="text-muted">Copyright &copy; Company - All rights reserved</p>
      </div>
    </footer>
  </div>
</template>

<script>

import { sha256, toHex, hexToBase64, randomString, replaceSpecialCharacter } from "@/utils/auth.js";

import { ref, onMounted } from "vue";

export default {
  setup() {
    const codeVerifier = ref(randomString(64));
    const challengeCode = ref('');

    const computeChallengeCode = async () => {
      window.sessionStorage.setItem("codeVerifier", codeVerifier.value);
      const hash = await sha256(codeVerifier.value);
      const hex = toHex(hash);
      challengeCode.value = replaceSpecialCharacter(hexToBase64(hex));
    };

    onMounted(async () => {
      await computeChallengeCode();
    });

    return {
      challengeCode
    };
  }
};
</script>

<style scoped>
.wrapper {
  -webkit-transition: all 0.5s cubic-bezier(0.685, 0.0473, 0.346, 1);
  -moz-transition: all 0.5s cubic-bezier(0.685, 0.0473, 0.346, 1);
  -o-transition: all 0.5s cubic-bezier(0.685, 0.0473, 0.346, 1);
  -ms-transition: all 0.5s cubic-bezier(0.685, 0.0473, 0.346, 1);
  transition: all 0.5s cubic-bezier(0.685, 0.0473, 0.346, 1);
  background-color: white;
}

.navbar-transparent {
  padding-top: 15px;
  background-color: transparent;
  border-bottom: 1px solid transparent;
}

.parallax {
  width: 100%;
  height: 570px;
  overflow: hidden;
  display: block;
}

.parallax .small-info {
  top: 20%;
  position: absolute;
  text-align: center;
  width: 100%;
  z-index: 2;
}

.parallax .small-info h3 {
  max-width: 790px;
  margin: 0 auto;
  line-height: 1.4;
}

.parallax .parallax-image {
  background: url(../../public/img/bg.png);
  height: 100%;
}

.parallax .parallax-image img {
  width: 100%;
  position: relative;
}

.filter-black {
  position: relative;
}

.filter-black:after {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  display: block;
  z-index: 1;
  background-color: rgba(0, 0, 0, 0.46);
  content: "";
}

.card {
  position: relative;
  background-color: #fff;
  border: 1px solid #eee;
  border-radius: 3px;
}

.card,
.list-group {
  margin-bottom: 1.25rem;
}

.card {
  box-shadow: 0 2px 3px rgba(0, 0, 0, 0.05);
}

.login-btn {
  background-color: #6943b6;
  color: #fff;
  padding: 12px 20px;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  font-size: 16px;
}

@media (min-width: 544px) {
  .card-group .card {
    display: table-cell;
    vertical-align: top;
  }
  .card-group .card + .card {
    margin-left: 0;
    border-left: 0;
  }
  .card-group .card:last-child {
    border-bottom-left-radius: 0;
    border-top-left-radius: 0;
  }
  .card-group .card:first-child {
    border-bottom-right-radius: 0;
    border-top-right-radius: 0;
  }
  .card-group {
    display: table;
    width: 100%;
    table-layout: fixed;
  }
}

@media all and (max-width: 544px) {
  .parallax {
    height: 750px !important;
  }
}

.card-group {
  margin-bottom: 1.25rem;
}

.card > .card-block > :last-child,
.card > :last-child {
  margin-bottom: 0 !important;
}

.card-block {
  padding: 1.25rem;
}

.center {
  text-align: center;
}
.m-a-2 {
  margin: 1.5rem !important;
}

.welcome-title {
  background: #fff;
  font-size: 60px;
  margin-top: 30px;
  font-weight: bold;
  color: #2dc3e8;
  text-shadow: 0 0 3px rgba(0, 0, 0, 0.5);
  text-shadow: 4px 3px 0 #fff, 9px 8px 0 rgba(0, 0, 0, 0.15);
}
</style>